"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderHeadshotDumpling = exports.checkIfLinkIsEmptyObject = void 0;
var _react = _interopRequireDefault(require("react"));
var _checkForDangerouslySet = require("../../utils/methods/checkForDangerouslySet");
var _lodash = require("lodash");
var _Image = _interopRequireDefault(require("../Image/Image"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderHeadshotDumpling = function (mouse, image, header, subHeader, text) {
  let link = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  let filter = arguments.length > 6 ? arguments[6] : undefined;
  let color = arguments.length > 7 ? arguments[7] : undefined;
  let GatsbyImage = arguments.length > 8 ? arguments[8] : undefined;
  return /*#__PURE__*/_react.default.createElement("article", {
    className: "ter-headshot-dumpling",
    tabIndex: mouse ? "" : "0"
  }, filter && filter === "blue" ? /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-headshot-dumpling__blue-filter"
  }, image && /*#__PURE__*/_react.default.createElement(_Image.default, {
    GatsbyImage: GatsbyImage,
    image: image?.image,
    className: "ter-headshot-dumpling__image ter-headshot-dumpling__image--blue",
    src: image?.src || image?.url,
    alt: image?.alt || image?.altText || "headshot"
  })) : image && /*#__PURE__*/_react.default.createElement(_Image.default, {
    GatsbyImage: GatsbyImage,
    image: image?.image,
    className: `ter-headshot-dumpling__image ${filter ? `ter-headshot-dumpling__image--${filter}` : ""}`,
    src: image?.src || image?.url,
    alt: image?.src || image?.altText || "headshot"
  }), header && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-headshot-dumpling__header",
    style: {
      color: color || "#242D2F"
    },
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
  }), subHeader && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-headshot-dumpling__sub-header",
    style: {
      color: color || "#242D2F"
    }
  }, subHeader), text && (0, _checkForDangerouslySet.checkAndSet)(text, "ter-headshot-dumpling", null, color));
};
exports.renderHeadshotDumpling = renderHeadshotDumpling;
const checkIfLinkIsEmptyObject = link => {
  return (0, _lodash.isEmpty)(link);
};
exports.checkIfLinkIsEmptyObject = checkIfLinkIsEmptyObject;